/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { useSelector } from 'react-redux';
import { getBrand } from '../../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
   footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.thankyoucards.footerBgColor,
   },
   innerFooter: {
      display: 'flex', 
      flexDirection: 'column', 
      padding: '1rem', 
      alignItems: 'center',
      '& p': {
         fontStyle: 'normal',
         fontWeight: 400,
         fontSize: '12px',
         lineHeight: '18px',
         display: 'flex',
         alignItems: 'center',
         textAlign: 'center',
         letterSpacing: '0.01em',
         color: theme.palette.common.white,
         margin: 0,
      },
      '& span': {
         color: theme.palette.common.white,
      },
      '& a': {
         textDecorationColor: theme.palette.common.white,
      }
   },
   linkContainer: {
      display: 'flex',
      alignItems: 'center'
   }
 }));

const RecipientFooter = () => {
   const classes = useStyles();
   const brand = useSelector(getBrand);
   const currentYear = new Date().getFullYear();
   const footerTitle = `© ${currentYear} ${brand['description']}.com, Inc., Jericho, NY Family of Brands`;
   const footerLinks = [
      { title: 'Terms of use', href: `https://www.${brand['domain-name']}.com/About-Us-Terms-of-Use` }, 
      { title: 'Privacy Notice', href: `https://www.${brand['domain-name']}.com/About-Us-Privacy-Policy` }, 
      { title: 'Accessibility Statement', href: `https://www.${brand['domain-name']}.com/About-Us-Terms-of-Use#accessibility-statement` }
   ];

   const footerLink = (title, href, index) => {
      return (
         <React.Fragment key={title}>
            <a
            key={title}
            href={href}
            >
               <p>{title}</p>
            </a>
            {index + 1 < footerLinks.length && <span>&nbsp;-&nbsp;</span>}
         </React.Fragment>
      )
   };
   
  return (
   <Grid className={classes.footer} height="auto" minHeight="110px">
      <div className={classes.innerFooter}>
         <p>{footerTitle}</p>
         <div className={classes.linkContainer}>
            {footerLinks?.map((link, index) => footerLink(link.title, link.href, index))}
         </div>
      </div>
   </Grid>
  )
}

export default RecipientFooter